// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/metropolis.medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Metropolis";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: 500;
  font-style: normal;
}

:root {
  --nav-bg: #0d2b6b;
  --page-bg: #eef2f6;
  --tab-surface: #eceff4;
  --card-surface: #f5f7fa;
  --brand: #3d74f5;
}

.custom-font {
  font-family: "Manrope", sans-serif;
}

.blur-modal + .modal-backdrop,
.modal-backdrop.show {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.35);
}

.blur-modal .modal-content {
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
}

.learn-details-modal.blurred-behind .modal-content {
  filter: blur(6px);
  transform: scale(0.98);
  opacity: 0.85;
  pointer-events: none;
  transition: all 0.25s ease;
}

.learn-details-modal .modal-content {
  transition: all 0.25s ease;
}

.ai-result-modal .modal-content {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

.logo-font {
  font-family: "Metropolis", sans-serif;
  letter-spacing: 1.1px;
  font-size: 28px;
  margin-bottom: 22px;
  font-weight: 700;
  text-align: center;
}

.learn-do-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.learn-text {
  color: #389c9a;
}

.plus-text {
  color: #000000;
}

.do-text {
  color: #f99e49;
}

.learn-do-logo {
  position: relative;
  z-index: 5;             
  isolation: isolate;       
}

.login-wrap {
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 100px;
  background-size: cover;
  background-position: center;
}

.confirm-update-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}

.confirm-update-box {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  animation: confirmFadeIn 0.18s ease;
}

.confirm-update-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.confirm-update-header h5 {
  font-size: 28px;
  font-weight: 500;
  color: #2b2b2b;
}

.confirm-update-close {
  border: none;
  background: transparent;
  font-size: 34px;
  line-height: 1;
  color: #1F2937;
  cursor: pointer;
}

.confirm-update-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.confirm-update-body {
  padding: 22px 20px 18px;
  font-size: 18px;
  color: #374151;
}

.confirm-update-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px 20px;
  border-top: 1px solid #e5e7eb;
}

@keyframes confirmFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.register-card {
  width: 600px;
  max-width: 100%;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(8px);
  border-radius: 22px;
  padding: 1px 24px;
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.register-card * {
  box-sizing: border-box;
}

.register-card h3 {
  text-align: center;
  font-weight: 800;
  letter-spacing: 1.2px;
  margin-bottom: 32px;
}

.register-card label {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 6px;
  color: #1b1e28;
}

.register-card .form-control,
.register-card .input-group {
  width: 100% !important;
  display: block;
  margin: 0 !important;
}

.register-card .form-control {
  height: 44px;
  border-radius: 10px !important;
  border: 1px solid #d7dbe3;
  padding-left: 12px;
  transition: box-shadow 0.2s, border-color 0.2s, background 0.2s;
  font-size: 15px;
  background: #ffffffc7;
  backdrop-filter: blur(2px);
}

.register-card .form-control:focus {
  outline: none;
  border-color: #448bff;
  box-shadow: 0 0 0 3px rgba(68, 139, 255, 0.18);
  background: #fff;
}

.text-holder::placeholder {
  font-family: "Manrope", system-ui, sans-serif;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #1F2937;
}

.name-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
}

@media (min-width: 768px) {
  .name-row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}
.name-row .form-control {
  margin: 0 !important;
}

.btn-register {
  width: 100%;
  background: #1f6cf0;
  color: white;
  border: none;
  padding: 10px;
  font-weight: 800;
  font-size: 16px;
  letter-spacing: 0.8px;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  transition: transform 0.1s ease, background 0.2s ease;
}
.btn-register:hover {
  background: #024fd1;
  transform: translateY(-1px);
}

.back-link {
  display: block;
  text-align: center;
  font-size: 14px;
  text-decoration: none;
  color: #1f6cf0;
  margin-top: 4px;
}
.back-link:hover {
  text-decoration: underline;
}

.phone-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
}

@media (max-width: 420px) {
  .phone-row {
    grid-template-columns: 1fr;
  }
}

.register-card .form-select {
  height: 44px;
  border-radius: 10px !important;
  border: 1px solid #d7dbe3;
  padding-left: 12px;
  font-size: 16px;
  background: #ffffffc7;
  transition: box-shadow 0.2s, border-color 0.2s, background 0.2s;
}

.register-card .form-select:focus {
  outline: none;
  border-color: #448bff;
  box-shadow: 0 0 0 3px rgba(68, 139, 255, 0.18);
  background: #fff;
}

.register-card .form-select,
.register-card .form-control {
  width: 100% !important;
  margin: 0 !important;
}

.pr-eye {
  padding-right: 44px !important;
}

.eye-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  height: 24px;
  width: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1F2937;
  cursor: pointer;
}

.eye-toggle:hover,
.eye-toggle:focus {
  color: #343a40;
  outline: none;
}

.eye-toggle:focus-visible {
  box-shadow: 0 0 0 0.2rem rgba(136, 29, 136, 0.15);
  border-radius: 8px;
}

.ld-card {
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.ld-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.ld-badge {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.ld-title {
  font-size: 18px;
  font-weight: 800;
  color: #1f2430;
  margin-top: 2px;
  letter-spacing: 0.2px;
}

.ld-subtitle {
  font-size: 13px;
  color: #1F2937;
  line-height: 1.35;
  margin-top: 2px;
}

.ld-cta {
  margin-top: 10px;
  background: #2e74ff;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.ld-cta:hover {
  filter: brightness(1.05);
}

@media (min-width: 768px) {
  .ld-card {
    height: 100%;
  }
}

.btn-explore {
  background: #2e74ff;
  border: none;
  border-radius: 999px;
  padding: 10px 22px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.btn-explore:hover {
  filter: brightness(1.03);
}

.course-card {
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  background: #f5f5f6;
}
.course-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.1);
}
.course-img {
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
}

.btn-enroll {
  background: #2e74ff;
  border: none;
  border-radius: 999px;
  font-weight: 700;
}

.custom-font,
.feature-card,
.course-card,
.btn-explore,
.btn-enroll {
  font-family: "Manrope", system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
}

.learn-wrap h4 {
  letter-spacing: 0.2px;
}

.card.shadow-sm {
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08) !important;
}

.file-box:focus {
  outline: 3px solid rgba(61, 116, 245, 0.35);
  outline-offset: 2px;
}

.form-control {
  border-radius: 10px;
}

@media (max-width: 991.98px) {
  .learn-topbar {
    height: 58px;
  }
}

.tmis-home {
  background: var(--page-bg);
  min-height: 100vh;
}

.tmis-topbar {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.tmis-topbar__inner {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tmis-logo {
  height: 46px;
  object-fit: contain;
}
.tmis-topbar__actions {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #29364a;
}
.tmis-topbar__user {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.tmis-hero {
  background: var(--nav-bg);
  color: #fff;
  padding: 40px 0 120px;
  position: relative;
  z-index: 1;
}
.tmis-hero__title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.4px;
}
.tmis-hero__subtitle {
  margin-top: 4px;
  font-size: 18px;
  opacity: 0.95;
}

.tmis-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  background: var(--tab-surface);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
  padding: 12px 18px;

  margin-top: -84px;
  position: relative;
  z-index: 3;
}

.tmis-tabs.tmis-tabs--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;
}

.tmis-row-expired {
  background-color: #f18888 !important;
}

.tmis-row-expired td {
  font-weight: 500;
  color: red !important;
}

.menu-pill {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 14px;
  padding: 14px 10px;
  background: linear-gradient(180deg, #ffffff, #f7f9fc);
  border: 1px solid #e5e8ee;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    border-color 0.15s ease;
  cursor: pointer;
}

.menu-pill:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(13, 43, 107, 0.12);
  border-color: #dbe2ee;
}

.menu-pill__icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.menu-pill__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.menu-pill__label {
  font-weight: 700;
  color: #263449;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
}

.tmis-features {
  padding: 32px 0 46px;
}
.feature-card {
  background: var(--card-surface);
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 18px 18px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.1);
}
.feature-card__img {
  width: 120px;
  height: 120px;
  margin: 6px 0 12px;
}
.feature-card__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.feature-card__title {
  font-weight: 800;
  color: #1f2a3c;
  font-size: 18px;
}
.feature-card__desc {
  color: #1F2937;
  font-size: 14px;
  margin-top: 6px;
  min-height: 54px;
}
.feature-card__btn {
  margin-top: 14px;
  padding: 8px 18px;
  border-radius: 999px;
  background: var(--brand);
  border: none;
}

@media (max-width: 992px) {
  .tmis-hero {
    padding: 36px 0 110px;
  }
  .tmis-tabs {
    margin-top: -76px;
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 768px) {
  .tmis-hero {
    padding: 28px 0 110px;
  }
  .tmis-tabs {
    margin-top: -72px;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 420px) {
  .tmis-hero {
    padding: 24px 0 100px;
  }
  .tmis-tabs {
    margin-top: -64px;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .menu-pill__label {
    font-size: 13px;
  }
}

.tmis-callout {
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 18px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  padding: 18px 20px;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 18px;
  align-items: center;
}

.tmis-callout__left {
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 14px;
  align-items: center;
}

.tmis-callout__avatar {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #eef2ff;
  color: #1a3584;
  display: grid;
  place-items: center;
  box-shadow: inset 0 0 0 1px rgba(26, 53, 132, 0.06);
}

.tmis-callout__texts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tmis-callout__title {
  font-weight: 700;
  font-size: clamp(16px, 1.2vw, 18px);
  color: #1a3584;
}

.tmis-callout__desc {
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
}

.tmis-callout__right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.tmis-steps {
  display: grid;
  gap: 8px;
  min-width: 260px;
  flex: 1 1 auto;
}

.tmis-step {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.tmis-step__icon {
  color: #10b981;
  margin-top: 2px;
  flex-shrink: 0;
}
.tmis-step__text {
  color: #1f2937;
  font-size: 14px;
  line-height: 1.4;
}

.tmis-callout__btn {
  background: #3d74f5 !important;
  border-color: #3d74f5 !important;
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(61, 116, 245, 0.25);
  white-space: nowrap;
}
.tmis-callout__btn:hover {
  filter: brightness(0.96);
}

.modal-xxl {
  max-width: 95% !important;
}

.tmis-blur-backdrop {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  background-color: rgba(0, 0, 0, 0.8) !important;
}

.modal-backdrop.tmis-blur-backdrop {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgba(15, 23, 42, 0.8) !important;

  z-index: 1060 !important;
}

.modal.tmis-top-modal {
  z-index: 1070 !important;
}

.badge-underscore-container {
  display: flex;
  gap: 14px;
  padding: 12px 4px;
  cursor: text;
  -webkit-user-select: none;
          user-select: none;
}

.badge-slot {
  font-size: 24px;
  font-weight: 600;
  color: #183b72;
  width: 22px;
  text-align: center;
  border-bottom: none;
}

.badge-real-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Metric cards (already similar, keep or merge with yours) */
.metric-card {
  position: relative;
  border: none;
  overflow: hidden;
  color: #ffffff !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.metric-card-body {
  padding: 18px 20px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.metric-label {
  font-size: 14px;
  letter-spacing: 0.3px;
}

.metric-value {
  font-size: 32px;
  font-weight: 700;
}

.metric-period-select {
  max-width: 120px;
  font-size: 12px;
  border-radius: 999px;
  border: none;
}

/* Gradients */
.metric-card--orange {
  background: linear-gradient(135deg, #c2410c, #b8420f);
}

.metric-card--blue {
  background: linear-gradient(135deg, #2f6fef, #2563eb);
}

.metric-card--teal {
  background: linear-gradient(135deg, #128278, #0e7c72);
}

.metric-card--purple {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
}

.metric-card--red {
  background: linear-gradient(135deg, #dc2626, #c81e1e);
}

/* Waves / blobs on all gradient cards */
.metric-card::before,
.metric-card::after {
  content: "";
  position: absolute;
  right: -40px;
  bottom: -40px;
  width: 140px;
  height: 140px;
  border-radius: 45% 55% 60% 40% / 45% 50% 55% 50%;
  opacity: 0.35;
  pointer-events: none;
}

.metric-card::after {
  right: -10px;
  bottom: -55px;
  width: 110px;
  height: 110px;
  border-radius: 60% 40% 55% 45% / 55% 45% 60% 40%;
  opacity: 0.22;
}

.metric-card--orange::before,
.metric-card--orange::after,
.metric-card--blue::before,
.metric-card--blue::after,
.metric-card--teal::before,
.metric-card--teal::after,
.metric-card--purple::before,
.metric-card--purple::after,
.metric-card--red::before,
.metric-card--red::after {
  background: radial-gradient(circle at 30% 30%, #ffffff60, #ffffff00);
}

/* ---------- Plain cards: darker surface so they read against the page bg ---------- */

.card.extra-white-card {
  background: #e3e8f0;
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.card.last-records-card,
.card.soon-expired-card {
  background: #e3e8f0;
}

/* Bootstrap's default text-muted/text-danger are tuned for a white card and
   drop below WCAG AA on this darker surface, so re-tune them here. */
.extra-white-card .text-muted,
.last-records-card .text-muted,
.soon-expired-card .text-muted {
  color: #1F2937 !important;
}

.extra-white-card .text-danger,
.last-records-card .text-danger,
.soon-expired-card .text-danger {
  color: #a4161a !important;
}

/* Bootstrap tables paint each cell with --bs-table-bg (defaults to the page's
   white body background), which shows through as white rows on these grey
   cards — force cells to stay transparent so the card colour shows instead. */
.extra-white-card .table,
.last-records-card .table,
.soon-expired-card .table {
  --bs-table-bg: transparent;
  --bs-table-striped-bg: transparent;
  --bs-table-hover-bg: transparent;
  --bs-table-color: #212529;
}

/* ---------- Last 5 records card ---------- */

.last-records-card {
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  min-height: 360px; /* roughly height of 3 small cards + gaps */
}

.last-records-body {
  padding: 18px 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.last-record-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.last-record-inner {
  position: relative;
  width: 100%;
  max-width: 360px;
  border-radius: 26px;
  padding: 28px 24px 22px;
  background: #d8dee8;
  text-align: center;
}

.last-record-extra-badge {
  position: absolute;
  top: -16px;
  right: 22px;
  padding: 4px 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, #c2410c, #dc2626);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}

.last-record-header-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 12px;
}

.last-record-badge-label {
  opacity: 0.7;
}

.last-record-badge-value {
  font-weight: 700;
  font-size: 18px;
}

.last-record-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
}

.last-record-avatar-text {
  pointer-events: none;
}

.last-record-name {
  font-weight: 600;
  margin-bottom: 5px;
}

.last-record-email {
  font-size: 12px;
  opacity: 0.85;
  margin-bottom: 5px;
}

.last-record-phone {
  font-size: 12px;
  margin-bottom: 5px;
}

.last-record-time {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 4px;
}

.last-record-meta {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  opacity: 0.75;
}

.last-record-datetime-pill {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 15px 15px;
  margin: 10px 0 16px;
  border-radius: 999px;
  background: linear-gradient(135deg, #4338ca, #2563eb);
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.18),
    0 1px 0 rgba(255, 255, 255, 0.8) inset;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
}

.last-record-datetime-item {
  display: inline-flex;
  align-items: center;
}

.last-record-datetime-item svg {
  /* little glow on icons */
  filter: drop-shadow(0 1px 2px rgba(15, 23, 42, 0.35));
}

/* ---------- Soon Expired card height ---------- */

.soon-expired-card {
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  min-height: 240px; /* ~ height of 2 small cards + gap */
}

.soon-expired-body {
  padding: 18px 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.last-record-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-top: 18px;
}

.last-record-nav-btn {
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  background: #d8dee8;
  color: #555;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.08s ease, opacity 0.1s;
}

.last-record-nav-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}

.last-record-nav-btn:disabled {
  opacity: 0.45;
  cursor: default;
  box-shadow: none;
}

.last-record-counter {
  font-size: 11px;
  opacity: 0.7;
}

/* Device 3D icons*/
.device-icon-3d {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 12px;
  font-size: 14px;
  /* generic soft 3D plate */
  background: linear-gradient(145deg, #f5f7ff, #d6ddf7);
  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.18),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;
  border: 1px solid rgba(255, 255, 255, 0.7);
}

.device-icon-3d svg {
  color: #ffffff;
}

/* Variants – tweak colours per type for more personality */
.device-icon-3d--phone {
  background: radial-gradient(circle at 30% 20%, #8ef0ff, #2563eb);
}

.device-icon-3d--desktop {
  background: radial-gradient(circle at 30% 20%, #d4f4ff, #1d4ed8);
}

.device-icon-3d--tablet {
  background: radial-gradient(circle at 30% 20%, #ffe6f7, #db2777);
}

.device-icon-3d--unknown {
  background: radial-gradient(circle at 30% 20%, #e5e7eb, #6b7280);
}

/* Browser flavour variants (optional but nice) */
.device-icon-3d--chrome {
  background: radial-gradient(circle at 30% 20%, #fcd34d, #ef4444);
}

.device-icon-3d--safari {
  background: radial-gradient(circle at 30% 20%, #bfdbfe, #0ea5e9);
}

.device-icon-3d--edge {
  background: radial-gradient(circle at 30% 20%, #bbf7d0, #16a34a);
}

.device-icon-3d--firefox {
  background: radial-gradient(circle at 30% 20%, #fed7aa, #ea580c);
}

/* From Uiverse.io by FColombati */
.button {
  all: unset;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
  border-radius: 100em;
  background-color: rgba(0, 0, 0, 0.75);
  box-shadow: -0.15em -0.15em 0.15em -0.075em rgba(5, 5, 5, 0.25),
    0.0375em 0.0375em 0.0675em 0 rgba(5, 5, 5, 0.1);
}

.button::after {
  content: "";
  position: absolute;
  z-index: 0;
  width: calc(100% + 0.3em);
  height: calc(100% + 0.3em);
  top: -0.15em;
  left: -0.15em;
  border-radius: inherit;
  background: linear-gradient(
    -135deg,
    rgba(5, 5, 5, 0.5),
    transparent 20%,
    transparent 100%
  );
  filter: blur(0.0125em);
  opacity: 0.25;
  mix-blend-mode: multiply;
}

.button .button-outer {
  position: relative;
  z-index: 1;
  border-radius: inherit;
  transition: box-shadow 300ms ease;
  will-change: box-shadow;
  box-shadow: 0 0.05em 0.05em -0.01em rgba(5, 5, 5, 1),
    0 0.01em 0.01em -0.01em rgba(5, 5, 5, 0.5),
    0.15em 0.3em 0.1em -0.01em rgba(5, 5, 5, 0.25);
}

.button:hover .button-outer {
  box-shadow: 0 0 0 0 rgba(5, 5, 5, 1), 0 0 0 0 rgba(5, 5, 5, 0.5),
    0 0 0 0 rgba(5, 5, 5, 0.25);
}

.button-inner {
  --inset: 0.035em;
  position: relative;
  z-index: 1;
  border-radius: inherit;
  padding: 1em 1.5em;
  background-image: linear-gradient(
    135deg,
    rgba(230, 230, 230, 1),
    rgba(180, 180, 180, 1)
  );
  transition: box-shadow 300ms ease, clip-path 250ms ease,
    background-image 250ms ease, transform 250ms ease;
  will-change: box-shadow, clip-path, background-image, transform;
  overflow: clip;
  clip-path: inset(0 0 0 0 round 100em);
  box-shadow:
        /* 1 */ 0 0 0 0 inset rgba(5, 5, 5, 0.1),
    /* 2 */ -0.05em -0.05em 0.05em 0 inset rgba(5, 5, 5, 0.25),
    /* 3 */ 0 0 0 0 inset rgba(5, 5, 5, 0.1),
    /* 4 */ 0 0 0.05em 0.2em inset rgba(255, 255, 255, 0.25),
    /* 5 */ 0.025em 0.05em 0.1em 0 inset rgba(255, 255, 255, 1),
    /* 6 */ 0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25),
    /* 7 */ -0.075em -0.25em 0.25em 0.1em inset rgba(5, 5, 5, 0.25);
}

.button:hover .button-inner {
  clip-path: inset(
    clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px)
      clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px) round 100em
  );
  box-shadow:
        /* 1 */ 0.1em 0.15em 0.05em 0 inset rgba(5, 5, 5, 0.75),
    /* 2 */ -0.025em -0.03em 0.05em 0.025em inset rgba(5, 5, 5, 0.5),
    /* 3 */ 0.25em 0.25em 0.2em 0 inset rgba(5, 5, 5, 0.5),
    /* 4 */ 0 0 0.05em 0.5em inset rgba(255, 255, 255, 0.15),
    /* 5 */ 0 0 0 0 inset rgba(255, 255, 255, 1),
    /* 6 */ 0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25),
    /* 7 */ -0.075em -0.12em 0.2em 0.1em inset rgba(5, 5, 5, 0.25);
}

.button .button-inner span {
  position: relative;
  z-index: 4;
  font-family: "Inter", sans-serif;
  letter-spacing: -0.05em;
  font-weight: 500;
  color: rgba(0, 0, 0, 0);
  background-image: linear-gradient(
    135deg,
    rgba(25, 25, 25, 1),
    rgba(75, 75, 75, 1)
  );
  -webkit-background-clip: text;
  background-clip: text;
  transition: transform 250ms ease;
  display: block;
  will-change: transform;
  text-shadow: rgba(0, 0, 0, 0.1) 0 0 0.1em;
  -webkit-user-select: none;
  user-select: none;
}

.button:hover .button-inner span {
  transform: scale(0.975);
}

.button:active .button-inner {
  transform: scale(0.975);
}

.audit-table td,
.audit-table th {
  vertical-align: middle;
  white-space: nowrap;
}

.col-date {
  width: 10px;
}
.col-time {
  width: 10px;
}
.col-user {
  width: 120px;
}
.col-name {
  width: 140px;
}
.col-type {
  width: 120px;
}
.col-subject {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tmis-scroll-top-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3b82f6;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.35);
  cursor: pointer;
  z-index: 9999;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.tmis-scroll-top-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px rgba(15, 23, 42, 0.45);
}

.tmis-scroll-top-fab:active {
  transform: translateY(0);
  box-shadow: 0 6px 12px rgba(15, 23, 42, 0.3);
}

.device-scroll-area {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 6px;
}

/* nicer scrollbar */
.device-scroll-area::-webkit-scrollbar {
  width: 6px;
}

.device-scroll-area::-webkit-scrollbar-track {
  background: transparent;
}

.device-scroll-area::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.device-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* From Uiverse.io by ryota1231 */ 
.animated-button {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 16px 36px;
  border: 4px solid;
  border-color: transparent;
  font-size: 16px;
  border-radius: 100px;
  font-weight: 600;
  color: #1f387e;
  box-shadow: 0 0 0 2px #ffffff;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button svg {
  position: absolute;
  width: 24px;
  fill: #1f387e;
  z-index: 9;
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button .arr-1 {
  right: 16px;
}

.animated-button .arr-2 {
  left: -25%;
}

.animated-button .circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background-color: #c5e5e4;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button .text {
  position: relative;
  z-index: 1;
  transform: translateX(-12px);
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button:hover {
  box-shadow: 0 0 0 12px transparent;
  color: #212121;
  border-radius: 12px;
}

.animated-button:hover .arr-1 {
  right: -25%;
}

.animated-button:hover .arr-2 {
  left: 16px;
}

.animated-button:hover .text {
  transform: translateX(12px);
}

.animated-button:hover svg {
  fill: #1f387e;
}

.animated-button:active {
  scale: 0.95;
  box-shadow: 0 0 0 4px #1f387e;
}

.animated-button:hover .circle {
  width: 220px;
  height: 220px;
  opacity: 1;
}

.status-mini-card {
  border-radius: 18px;
  padding: 16px 10px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #edf0f5;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.status-count {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 10px;
}

.status-label {
  font-size: 13px;
  font-weight: 700;
}

.status-approved {
  background: #AAFFC7;
  color: #215B63;
}

.status-pending {
  background: #FACE68;
  color: #6b3f00;
}

.status-resubmit {
  background: #F3BE7A;
  color: #6b2800;
}

.status-rejected {
  background: #BFC6C4;
  color: #111F35;
}

@media (max-width: 576px) {
  .status-mini-card {
    min-height: 95px;
    padding: 14px 8px;
  }

  .status-count {
    font-size: 24px;
  }

  .status-label {
    font-size: 12px;
  }
}

@keyframes overlay {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.button:focus {
  outline: none;
}

@media (max-width: 992px) {
  .tmis-callout {
    grid-template-columns: 1fr;
  }
  .tmis-callout__right {
    justify-content: flex-start;
  }
}

/* darker secondary text for readability */
.text-muted,
.form-text,
.small.text-muted {
  color: #1F2937 !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,+DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,0BAA0B;EAC1B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,+DAA+D;EAC/D,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;;;EAKE,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;;EAElB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,yBAAyB;EACzB;2BACyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;;EAElD,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,wCAAwC;AACxC;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,oEAAoE;AACtE;;AAEA,uFAAuF;;AAEvF;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;qEACqE;AACrE;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;8EAE8E;AAC9E;;;EAGE,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,8CAA8C;;AAE9C;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB,EAAE,2CAA2C;AAChE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;EACrD;0CACwC;EACxC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA,mDAAmD;;AAEnD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,qDAAqD;EACrD;0CACwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA,iDAAiD;AACjD;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC;mDACiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB;;;;;GAKC;EACD,sBAAsB;EACtB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB;;kDAEgD;AAClD;;AAEA;EACE;+BAC6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB;;;;GAIC;EACD;qDACmD;EACnD,+DAA+D;EAC/D,cAAc;EACd,qCAAqC;EACrC;;;;;;;mEAOiE;AACnE;;AAEA;EACE;;;GAGC;EACD;;;;;;;kEAOgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB;;;;GAIC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,aAAa;EACb,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,0CAA0C;AAC1C;;;EAGE,yBAAyB;AAC3B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap\");\n\n@font-face {\n  font-family: \"Metropolis\";\n  src: url(\"fonts/metropolis.medium.otf\") format(\"opentype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n:root {\n  --nav-bg: #0d2b6b;\n  --page-bg: #eef2f6;\n  --tab-surface: #eceff4;\n  --card-surface: #f5f7fa;\n  --brand: #3d74f5;\n}\n\n.custom-font {\n  font-family: \"Manrope\", sans-serif;\n}\n\n.blur-modal + .modal-backdrop,\n.modal-backdrop.show {\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  background-color: rgba(0, 0, 0, 0.35);\n}\n\n.blur-modal .modal-content {\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n}\n\n.learn-details-modal.blurred-behind .modal-content {\n  filter: blur(6px);\n  transform: scale(0.98);\n  opacity: 0.85;\n  pointer-events: none;\n  transition: all 0.25s ease;\n}\n\n.learn-details-modal .modal-content {\n  transition: all 0.25s ease;\n}\n\n.ai-result-modal .modal-content {\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n}\n\n.logo-font {\n  font-family: \"Metropolis\", sans-serif;\n  letter-spacing: 1.1px;\n  font-size: 28px;\n  margin-bottom: 22px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.learn-do-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n\n.learn-text {\n  color: #389c9a;\n}\n\n.plus-text {\n  color: #000000;\n}\n\n.do-text {\n  color: #f99e49;\n}\n\n.learn-do-logo {\n  position: relative;\n  z-index: 5;             \n  isolation: isolate;       \n}\n\n.login-wrap {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  padding-top: 100px;\n  background-size: cover;\n  background-position: center;\n}\n\n.confirm-update-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.35);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 16px;\n}\n\n.confirm-update-box {\n  width: 100%;\n  max-width: 520px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n  animation: confirmFadeIn 0.18s ease;\n}\n\n.confirm-update-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.confirm-update-header h5 {\n  font-size: 28px;\n  font-weight: 500;\n  color: #2b2b2b;\n}\n\n.confirm-update-close {\n  border: none;\n  background: transparent;\n  font-size: 34px;\n  line-height: 1;\n  color: #1F2937;\n  cursor: pointer;\n}\n\n.confirm-update-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.confirm-update-body {\n  padding: 22px 20px 18px;\n  font-size: 18px;\n  color: #374151;\n}\n\n.confirm-update-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 20px 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n@keyframes confirmFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.register-card {\n  width: 600px;\n  max-width: 100%;\n  background: rgba(255, 255, 255, 0.78);\n  backdrop-filter: blur(8px);\n  border-radius: 22px;\n  padding: 1px 24px;\n  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.12);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.register-card * {\n  box-sizing: border-box;\n}\n\n.register-card h3 {\n  text-align: center;\n  font-weight: 800;\n  letter-spacing: 1.2px;\n  margin-bottom: 32px;\n}\n\n.register-card label {\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 6px;\n  color: #1b1e28;\n}\n\n.register-card .form-control,\n.register-card .input-group {\n  width: 100% !important;\n  display: block;\n  margin: 0 !important;\n}\n\n.register-card .form-control {\n  height: 44px;\n  border-radius: 10px !important;\n  border: 1px solid #d7dbe3;\n  padding-left: 12px;\n  transition: box-shadow 0.2s, border-color 0.2s, background 0.2s;\n  font-size: 15px;\n  background: #ffffffc7;\n  backdrop-filter: blur(2px);\n}\n\n.register-card .form-control:focus {\n  outline: none;\n  border-color: #448bff;\n  box-shadow: 0 0 0 3px rgba(68, 139, 255, 0.18);\n  background: #fff;\n}\n\n.text-holder::placeholder {\n  font-family: \"Manrope\", system-ui, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 0.2px;\n  color: #1F2937;\n}\n\n.name-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 12px;\n}\n\n@media (min-width: 768px) {\n  .name-row {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n.name-row .form-control {\n  margin: 0 !important;\n}\n\n.btn-register {\n  width: 100%;\n  background: #1f6cf0;\n  color: white;\n  border: none;\n  padding: 10px;\n  font-weight: 800;\n  font-size: 16px;\n  letter-spacing: 0.8px;\n  border-radius: 10px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  transition: transform 0.1s ease, background 0.2s ease;\n}\n.btn-register:hover {\n  background: #024fd1;\n  transform: translateY(-1px);\n}\n\n.back-link {\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  text-decoration: none;\n  color: #1f6cf0;\n  margin-top: 4px;\n}\n.back-link:hover {\n  text-decoration: underline;\n}\n\n.phone-row {\n  display: grid;\n  grid-template-columns: 160px 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 420px) {\n  .phone-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.register-card .form-select {\n  height: 44px;\n  border-radius: 10px !important;\n  border: 1px solid #d7dbe3;\n  padding-left: 12px;\n  font-size: 16px;\n  background: #ffffffc7;\n  transition: box-shadow 0.2s, border-color 0.2s, background 0.2s;\n}\n\n.register-card .form-select:focus {\n  outline: none;\n  border-color: #448bff;\n  box-shadow: 0 0 0 3px rgba(68, 139, 255, 0.18);\n  background: #fff;\n}\n\n.register-card .form-select,\n.register-card .form-control {\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n.pr-eye {\n  padding-right: 44px !important;\n}\n\n.eye-toggle {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  border: 0;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  height: 24px;\n  width: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #1F2937;\n  cursor: pointer;\n}\n\n.eye-toggle:hover,\n.eye-toggle:focus {\n  color: #343a40;\n  outline: none;\n}\n\n.eye-toggle:focus-visible {\n  box-shadow: 0 0 0 0.2rem rgba(136, 29, 136, 0.15);\n  border-radius: 8px;\n}\n\n.ld-card {\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.ld-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);\n}\n\n.ld-badge {\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n}\n\n.ld-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #1f2430;\n  margin-top: 2px;\n  letter-spacing: 0.2px;\n}\n\n.ld-subtitle {\n  font-size: 13px;\n  color: #1F2937;\n  line-height: 1.35;\n  margin-top: 2px;\n}\n\n.ld-cta {\n  margin-top: 10px;\n  background: #2e74ff;\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n.ld-cta:hover {\n  filter: brightness(1.05);\n}\n\n@media (min-width: 768px) {\n  .ld-card {\n    height: 100%;\n  }\n}\n\n.btn-explore {\n  background: #2e74ff;\n  border: none;\n  border-radius: 999px;\n  padding: 10px 22px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n.btn-explore:hover {\n  filter: brightness(1.03);\n}\n\n.course-card {\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  background: #f5f5f6;\n}\n.course-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.1);\n}\n.course-img {\n  width: 100%;\n  height: 150px;\n  background-size: cover;\n  background-position: center;\n}\n\n.btn-enroll {\n  background: #2e74ff;\n  border: none;\n  border-radius: 999px;\n  font-weight: 700;\n}\n\n.custom-font,\n.feature-card,\n.course-card,\n.btn-explore,\n.btn-enroll {\n  font-family: \"Manrope\", system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\n}\n\n.learn-wrap h4 {\n  letter-spacing: 0.2px;\n}\n\n.card.shadow-sm {\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08) !important;\n}\n\n.file-box:focus {\n  outline: 3px solid rgba(61, 116, 245, 0.35);\n  outline-offset: 2px;\n}\n\n.form-control {\n  border-radius: 10px;\n}\n\n@media (max-width: 991.98px) {\n  .learn-topbar {\n    height: 58px;\n  }\n}\n\n.tmis-home {\n  background: var(--page-bg);\n  min-height: 100vh;\n}\n\n.tmis-topbar {\n  background: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n.tmis-topbar__inner {\n  height: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.tmis-logo {\n  height: 46px;\n  object-fit: contain;\n}\n.tmis-topbar__actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  color: #29364a;\n}\n.tmis-topbar__user {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n\n.tmis-hero {\n  background: var(--nav-bg);\n  color: #fff;\n  padding: 40px 0 120px;\n  position: relative;\n  z-index: 1;\n}\n.tmis-hero__title {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n}\n.tmis-hero__subtitle {\n  margin-top: 4px;\n  font-size: 18px;\n  opacity: 0.95;\n}\n\n.tmis-tabs {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 18px;\n  background: var(--tab-surface);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 18px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);\n  padding: 12px 18px;\n\n  margin-top: -84px;\n  position: relative;\n  z-index: 3;\n}\n\n.tmis-tabs.tmis-tabs--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  justify-content: center;\n}\n\n.tmis-row-expired {\n  background-color: #f18888 !important;\n}\n\n.tmis-row-expired td {\n  font-weight: 500;\n  color: red !important;\n}\n\n.menu-pill {\n  user-select: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 14px;\n  padding: 14px 10px;\n  background: linear-gradient(180deg, #ffffff, #f7f9fc);\n  border: 1px solid #e5e8ee;\n  transition: transform 0.15s ease, box-shadow 0.15s ease,\n    border-color 0.15s ease;\n  cursor: pointer;\n}\n\n.menu-pill:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 28px rgba(13, 43, 107, 0.12);\n  border-color: #dbe2ee;\n}\n\n.menu-pill__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.menu-pill__icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.menu-pill__label {\n  font-weight: 700;\n  color: #263449;\n  font-size: 14px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.tmis-features {\n  padding: 32px 0 46px;\n}\n.feature-card {\n  background: var(--card-surface);\n  border-radius: 18px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  padding: 18px 18px 20px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.feature-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.1);\n}\n.feature-card__img {\n  width: 120px;\n  height: 120px;\n  margin: 6px 0 12px;\n}\n.feature-card__img img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.feature-card__title {\n  font-weight: 800;\n  color: #1f2a3c;\n  font-size: 18px;\n}\n.feature-card__desc {\n  color: #1F2937;\n  font-size: 14px;\n  margin-top: 6px;\n  min-height: 54px;\n}\n.feature-card__btn {\n  margin-top: 14px;\n  padding: 8px 18px;\n  border-radius: 999px;\n  background: var(--brand);\n  border: none;\n}\n\n@media (max-width: 992px) {\n  .tmis-hero {\n    padding: 36px 0 110px;\n  }\n  .tmis-tabs {\n    margin-top: -76px;\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n@media (max-width: 768px) {\n  .tmis-hero {\n    padding: 28px 0 110px;\n  }\n  .tmis-tabs {\n    margin-top: -72px;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 420px) {\n  .tmis-hero {\n    padding: 24px 0 100px;\n  }\n  .tmis-tabs {\n    margin-top: -64px;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n  .menu-pill__label {\n    font-size: 13px;\n  }\n}\n\n.tmis-callout {\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 18px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);\n  padding: 18px 20px;\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 18px;\n  align-items: center;\n}\n\n.tmis-callout__left {\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 14px;\n  align-items: center;\n}\n\n.tmis-callout__avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #1a3584;\n  display: grid;\n  place-items: center;\n  box-shadow: inset 0 0 0 1px rgba(26, 53, 132, 0.06);\n}\n\n.tmis-callout__texts {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tmis-callout__title {\n  font-weight: 700;\n  font-size: clamp(16px, 1.2vw, 18px);\n  color: #1a3584;\n}\n\n.tmis-callout__desc {\n  color: #374151;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.tmis-callout__right {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.tmis-steps {\n  display: grid;\n  gap: 8px;\n  min-width: 260px;\n  flex: 1 1 auto;\n}\n\n.tmis-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.tmis-step__icon {\n  color: #10b981;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n.tmis-step__text {\n  color: #1f2937;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.tmis-callout__btn {\n  background: #3d74f5 !important;\n  border-color: #3d74f5 !important;\n  border-radius: 12px;\n  padding: 10px 16px;\n  font-weight: 600;\n  box-shadow: 0 6px 16px rgba(61, 116, 245, 0.25);\n  white-space: nowrap;\n}\n.tmis-callout__btn:hover {\n  filter: brightness(0.96);\n}\n\n.modal-xxl {\n  max-width: 95% !important;\n}\n\n.tmis-blur-backdrop {\n  backdrop-filter: blur(12px) !important;\n  -webkit-backdrop-filter: blur(12px) !important;\n  background-color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.modal-backdrop.tmis-blur-backdrop {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  background-color: rgba(15, 23, 42, 0.8) !important;\n\n  z-index: 1060 !important;\n}\n\n.modal.tmis-top-modal {\n  z-index: 1070 !important;\n}\n\n.badge-underscore-container {\n  display: flex;\n  gap: 14px;\n  padding: 12px 4px;\n  cursor: text;\n  user-select: none;\n}\n\n.badge-slot {\n  font-size: 24px;\n  font-weight: 600;\n  color: #183b72;\n  width: 22px;\n  text-align: center;\n  border-bottom: none;\n}\n\n.badge-real-input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Metric cards (already similar, keep or merge with yours) */\n.metric-card {\n  position: relative;\n  border: none;\n  overflow: hidden;\n  color: #ffffff !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n}\n\n.metric-card-body {\n  padding: 18px 20px;\n  min-height: 110px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.metric-label {\n  font-size: 14px;\n  letter-spacing: 0.3px;\n}\n\n.metric-value {\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.metric-period-select {\n  max-width: 120px;\n  font-size: 12px;\n  border-radius: 999px;\n  border: none;\n}\n\n/* Gradients */\n.metric-card--orange {\n  background: linear-gradient(135deg, #c2410c, #b8420f);\n}\n\n.metric-card--blue {\n  background: linear-gradient(135deg, #2f6fef, #2563eb);\n}\n\n.metric-card--teal {\n  background: linear-gradient(135deg, #128278, #0e7c72);\n}\n\n.metric-card--purple {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n}\n\n.metric-card--red {\n  background: linear-gradient(135deg, #dc2626, #c81e1e);\n}\n\n/* Waves / blobs on all gradient cards */\n.metric-card::before,\n.metric-card::after {\n  content: \"\";\n  position: absolute;\n  right: -40px;\n  bottom: -40px;\n  width: 140px;\n  height: 140px;\n  border-radius: 45% 55% 60% 40% / 45% 50% 55% 50%;\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n.metric-card::after {\n  right: -10px;\n  bottom: -55px;\n  width: 110px;\n  height: 110px;\n  border-radius: 60% 40% 55% 45% / 55% 45% 60% 40%;\n  opacity: 0.22;\n}\n\n.metric-card--orange::before,\n.metric-card--orange::after,\n.metric-card--blue::before,\n.metric-card--blue::after,\n.metric-card--teal::before,\n.metric-card--teal::after,\n.metric-card--purple::before,\n.metric-card--purple::after,\n.metric-card--red::before,\n.metric-card--red::after {\n  background: radial-gradient(circle at 30% 30%, #ffffff60, #ffffff00);\n}\n\n/* ---------- Plain cards: darker surface so they read against the page bg ---------- */\n\n.card.extra-white-card {\n  background: #e3e8f0;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.card.last-records-card,\n.card.soon-expired-card {\n  background: #e3e8f0;\n}\n\n/* Bootstrap's default text-muted/text-danger are tuned for a white card and\n   drop below WCAG AA on this darker surface, so re-tune them here. */\n.extra-white-card .text-muted,\n.last-records-card .text-muted,\n.soon-expired-card .text-muted {\n  color: #1F2937 !important;\n}\n\n.extra-white-card .text-danger,\n.last-records-card .text-danger,\n.soon-expired-card .text-danger {\n  color: #a4161a !important;\n}\n\n/* Bootstrap tables paint each cell with --bs-table-bg (defaults to the page's\n   white body background), which shows through as white rows on these grey\n   cards — force cells to stay transparent so the card colour shows instead. */\n.extra-white-card .table,\n.last-records-card .table,\n.soon-expired-card .table {\n  --bs-table-bg: transparent;\n  --bs-table-striped-bg: transparent;\n  --bs-table-hover-bg: transparent;\n  --bs-table-color: #212529;\n}\n\n/* ---------- Last 5 records card ---------- */\n\n.last-records-card {\n  border-radius: 22px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  min-height: 360px; /* roughly height of 3 small cards + gaps */\n}\n\n.last-records-body {\n  padding: 18px 24px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.last-record-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.last-record-inner {\n  position: relative;\n  width: 100%;\n  max-width: 360px;\n  border-radius: 26px;\n  padding: 28px 24px 22px;\n  background: #d8dee8;\n  text-align: center;\n}\n\n.last-record-extra-badge {\n  position: absolute;\n  top: -16px;\n  right: 22px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #c2410c, #dc2626);\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);\n}\n\n.last-record-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  font-size: 12px;\n}\n\n.last-record-badge-label {\n  opacity: 0.7;\n}\n\n.last-record-badge-value {\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.last-record-avatar {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  margin: 0 auto 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);\n}\n\n.last-record-avatar-text {\n  pointer-events: none;\n}\n\n.last-record-name {\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.last-record-email {\n  font-size: 12px;\n  opacity: 0.85;\n  margin-bottom: 5px;\n}\n\n.last-record-phone {\n  font-size: 12px;\n  margin-bottom: 5px;\n}\n\n.last-record-time {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-top: 4px;\n}\n\n.last-record-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  opacity: 0.75;\n}\n\n.last-record-datetime-pill {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 15px 15px;\n  margin: 10px 0 16px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #4338ca, #2563eb);\n  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.18),\n    0 1px 0 rgba(255, 255, 255, 0.8) inset;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.last-record-datetime-item {\n  display: inline-flex;\n  align-items: center;\n}\n\n.last-record-datetime-item svg {\n  /* little glow on icons */\n  filter: drop-shadow(0 1px 2px rgba(15, 23, 42, 0.35));\n}\n\n/* ---------- Soon Expired card height ---------- */\n\n.soon-expired-card {\n  border-radius: 22px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  min-height: 240px; /* ~ height of 2 small cards + gap */\n}\n\n.soon-expired-body {\n  padding: 18px 24px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.last-record-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  margin-top: 18px;\n}\n\n.last-record-nav-btn {\n  border: none;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #d8dee8;\n  color: #555;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  transition: transform 0.08s ease, box-shadow 0.08s ease, opacity 0.1s;\n}\n\n.last-record-nav-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);\n}\n\n.last-record-nav-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n  box-shadow: none;\n}\n\n.last-record-counter {\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n/* Device 3D icons*/\n.device-icon-3d {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 12px;\n  font-size: 14px;\n  /* generic soft 3D plate */\n  background: linear-gradient(145deg, #f5f7ff, #d6ddf7);\n  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.18),\n    0 1px 0 rgba(255, 255, 255, 0.9) inset;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n}\n\n.device-icon-3d svg {\n  color: #ffffff;\n}\n\n/* Variants – tweak colours per type for more personality */\n.device-icon-3d--phone {\n  background: radial-gradient(circle at 30% 20%, #8ef0ff, #2563eb);\n}\n\n.device-icon-3d--desktop {\n  background: radial-gradient(circle at 30% 20%, #d4f4ff, #1d4ed8);\n}\n\n.device-icon-3d--tablet {\n  background: radial-gradient(circle at 30% 20%, #ffe6f7, #db2777);\n}\n\n.device-icon-3d--unknown {\n  background: radial-gradient(circle at 30% 20%, #e5e7eb, #6b7280);\n}\n\n/* Browser flavour variants (optional but nice) */\n.device-icon-3d--chrome {\n  background: radial-gradient(circle at 30% 20%, #fcd34d, #ef4444);\n}\n\n.device-icon-3d--safari {\n  background: radial-gradient(circle at 30% 20%, #bfdbfe, #0ea5e9);\n}\n\n.device-icon-3d--edge {\n  background: radial-gradient(circle at 30% 20%, #bbf7d0, #16a34a);\n}\n\n.device-icon-3d--firefox {\n  background: radial-gradient(circle at 30% 20%, #fed7aa, #ea580c);\n}\n\n/* From Uiverse.io by FColombati */\n.button {\n  all: unset;\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  position: relative;\n  border-radius: 100em;\n  background-color: rgba(0, 0, 0, 0.75);\n  box-shadow: -0.15em -0.15em 0.15em -0.075em rgba(5, 5, 5, 0.25),\n    0.0375em 0.0375em 0.0675em 0 rgba(5, 5, 5, 0.1);\n}\n\n.button::after {\n  content: \"\";\n  position: absolute;\n  z-index: 0;\n  width: calc(100% + 0.3em);\n  height: calc(100% + 0.3em);\n  top: -0.15em;\n  left: -0.15em;\n  border-radius: inherit;\n  background: linear-gradient(\n    -135deg,\n    rgba(5, 5, 5, 0.5),\n    transparent 20%,\n    transparent 100%\n  );\n  filter: blur(0.0125em);\n  opacity: 0.25;\n  mix-blend-mode: multiply;\n}\n\n.button .button-outer {\n  position: relative;\n  z-index: 1;\n  border-radius: inherit;\n  transition: box-shadow 300ms ease;\n  will-change: box-shadow;\n  box-shadow: 0 0.05em 0.05em -0.01em rgba(5, 5, 5, 1),\n    0 0.01em 0.01em -0.01em rgba(5, 5, 5, 0.5),\n    0.15em 0.3em 0.1em -0.01em rgba(5, 5, 5, 0.25);\n}\n\n.button:hover .button-outer {\n  box-shadow: 0 0 0 0 rgba(5, 5, 5, 1), 0 0 0 0 rgba(5, 5, 5, 0.5),\n    0 0 0 0 rgba(5, 5, 5, 0.25);\n}\n\n.button-inner {\n  --inset: 0.035em;\n  position: relative;\n  z-index: 1;\n  border-radius: inherit;\n  padding: 1em 1.5em;\n  background-image: linear-gradient(\n    135deg,\n    rgba(230, 230, 230, 1),\n    rgba(180, 180, 180, 1)\n  );\n  transition: box-shadow 300ms ease, clip-path 250ms ease,\n    background-image 250ms ease, transform 250ms ease;\n  will-change: box-shadow, clip-path, background-image, transform;\n  overflow: clip;\n  clip-path: inset(0 0 0 0 round 100em);\n  box-shadow:\n        /* 1 */ 0 0 0 0 inset rgba(5, 5, 5, 0.1),\n    /* 2 */ -0.05em -0.05em 0.05em 0 inset rgba(5, 5, 5, 0.25),\n    /* 3 */ 0 0 0 0 inset rgba(5, 5, 5, 0.1),\n    /* 4 */ 0 0 0.05em 0.2em inset rgba(255, 255, 255, 0.25),\n    /* 5 */ 0.025em 0.05em 0.1em 0 inset rgba(255, 255, 255, 1),\n    /* 6 */ 0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25),\n    /* 7 */ -0.075em -0.25em 0.25em 0.1em inset rgba(5, 5, 5, 0.25);\n}\n\n.button:hover .button-inner {\n  clip-path: inset(\n    clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px)\n      clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px) round 100em\n  );\n  box-shadow:\n        /* 1 */ 0.1em 0.15em 0.05em 0 inset rgba(5, 5, 5, 0.75),\n    /* 2 */ -0.025em -0.03em 0.05em 0.025em inset rgba(5, 5, 5, 0.5),\n    /* 3 */ 0.25em 0.25em 0.2em 0 inset rgba(5, 5, 5, 0.5),\n    /* 4 */ 0 0 0.05em 0.5em inset rgba(255, 255, 255, 0.15),\n    /* 5 */ 0 0 0 0 inset rgba(255, 255, 255, 1),\n    /* 6 */ 0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25),\n    /* 7 */ -0.075em -0.12em 0.2em 0.1em inset rgba(5, 5, 5, 0.25);\n}\n\n.button .button-inner span {\n  position: relative;\n  z-index: 4;\n  font-family: \"Inter\", sans-serif;\n  letter-spacing: -0.05em;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0);\n  background-image: linear-gradient(\n    135deg,\n    rgba(25, 25, 25, 1),\n    rgba(75, 75, 75, 1)\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  transition: transform 250ms ease;\n  display: block;\n  will-change: transform;\n  text-shadow: rgba(0, 0, 0, 0.1) 0 0 0.1em;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.button:hover .button-inner span {\n  transform: scale(0.975);\n}\n\n.button:active .button-inner {\n  transform: scale(0.975);\n}\n\n.audit-table td,\n.audit-table th {\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.col-date {\n  width: 10px;\n}\n.col-time {\n  width: 10px;\n}\n.col-user {\n  width: 120px;\n}\n.col-name {\n  width: 140px;\n}\n.col-type {\n  width: 120px;\n}\n.col-subject {\n  width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tmis-scroll-top-fab {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3b82f6;\n  color: #ffffff;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.35);\n  cursor: pointer;\n  z-index: 9999;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n}\n\n.tmis-scroll-top-fab:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 25px rgba(15, 23, 42, 0.45);\n}\n\n.tmis-scroll-top-fab:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 12px rgba(15, 23, 42, 0.3);\n}\n\n.device-scroll-area {\n  max-height: 240px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 6px;\n}\n\n/* nicer scrollbar */\n.device-scroll-area::-webkit-scrollbar {\n  width: 6px;\n}\n\n.device-scroll-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.device-scroll-area::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n}\n\n.device-scroll-area::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* From Uiverse.io by ryota1231 */ \n.animated-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 16px 36px;\n  border: 4px solid;\n  border-color: transparent;\n  font-size: 16px;\n  border-radius: 100px;\n  font-weight: 600;\n  color: #1f387e;\n  box-shadow: 0 0 0 2px #ffffff;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button svg {\n  position: absolute;\n  width: 24px;\n  fill: #1f387e;\n  z-index: 9;\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button .arr-1 {\n  right: 16px;\n}\n\n.animated-button .arr-2 {\n  left: -25%;\n}\n\n.animated-button .circle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 20px;\n  height: 20px;\n  background-color: #c5e5e4;\n  border-radius: 50%;\n  opacity: 0;\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button .text {\n  position: relative;\n  z-index: 1;\n  transform: translateX(-12px);\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button:hover {\n  box-shadow: 0 0 0 12px transparent;\n  color: #212121;\n  border-radius: 12px;\n}\n\n.animated-button:hover .arr-1 {\n  right: -25%;\n}\n\n.animated-button:hover .arr-2 {\n  left: 16px;\n}\n\n.animated-button:hover .text {\n  transform: translateX(12px);\n}\n\n.animated-button:hover svg {\n  fill: #1f387e;\n}\n\n.animated-button:active {\n  scale: 0.95;\n  box-shadow: 0 0 0 4px #1f387e;\n}\n\n.animated-button:hover .circle {\n  width: 220px;\n  height: 220px;\n  opacity: 1;\n}\n\n.status-mini-card {\n  border-radius: 18px;\n  padding: 16px 10px;\n  min-height: 110px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border: 1px solid #edf0f5;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);\n}\n\n.status-count {\n  font-size: 28px;\n  font-weight: 800;\n  line-height: 1;\n  margin-bottom: 10px;\n}\n\n.status-label {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.status-approved {\n  background: #AAFFC7;\n  color: #215B63;\n}\n\n.status-pending {\n  background: #FACE68;\n  color: #6b3f00;\n}\n\n.status-resubmit {\n  background: #F3BE7A;\n  color: #6b2800;\n}\n\n.status-rejected {\n  background: #BFC6C4;\n  color: #111F35;\n}\n\n@media (max-width: 576px) {\n  .status-mini-card {\n    min-height: 95px;\n    padding: 14px 8px;\n  }\n\n  .status-count {\n    font-size: 24px;\n  }\n\n  .status-label {\n    font-size: 12px;\n  }\n}\n\n@keyframes overlay {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.button:focus {\n  outline: none;\n}\n\n@media (max-width: 992px) {\n  .tmis-callout {\n    grid-template-columns: 1fr;\n  }\n  .tmis-callout__right {\n    justify-content: flex-start;\n  }\n}\n\n/* darker secondary text for readability */\n.text-muted,\n.form-text,\n.small.text-muted {\n  color: #1F2937 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
